// removed by extract-text-webpack-plugin
module.exports = {"color_primary_purple":"#4527a0","color_dark_purple_1":"#311b92","color_white":"#ffffff"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/base/_colors.scss
// module id = 484
// module chunks = 0